import { API } from "../../../../../../utility/API"

//************************************//
export const _resendEmailOTP = (callback, callbackErr) => {
  API.get(`/trading/account/withdraw_resend_email_otp`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error?.response?.data)
    })
}
//************************************//
